<template>
	<div class="content-wrapper">
		<div class="sf-flex-column" v-if="isLoaded">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<part-cost-search-container ref="partCostSearch" :scrId="scrId"></part-cost-search-container>
				</sf-card>
			</div>
			<div class="sf-col sf-col-14">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<part-cost-table-container
						ref="tableContainer"
						@Refresh="Refresh"
						@PopupOpen="PopupOpen"
						:scrId="scrId"
					></part-cost-table-container>
					<excel-upload-modal :scrId="scrId" ref="excelUploadPop" @Refresh="Refresh" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-6">
				<!-- <table-master-info :scrId="scrId" @OpenPopup="OpenPopup"></table-master-info> -->
				<part-cost-table-master-info
					ref="tablemasterinfo"
					@SendData="sendData"
					@Refresh="Refresh"
					:scrId="scrId"
				></part-cost-table-master-info>
			</div>
			<!--엑셀 업로드 팝업창 영역 끝-->
			<excel-upload-modal :scrId="scrId" ref="excelUploadPop" @Refresh="Refresh" />
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../store/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import PartCostSearchContainer from './Search/PartCostSearchContainer.vue';
import PartCostTableContainer from './Table/PartCostTableContainer.vue';
import PartCostTableMasterInfo from './Table/PartCostTableMasterInfo.vue';
import ExcelUploadModal from '@qms/Components/popup/ExcelUploadModal.vue'; //엑셀업로드 모달창
// import Variable from './Variable/Variable.vue';
// import Table2Container from './Table/Table2Container.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			sendParam: {},
			faivorite: true,
			screen: {},
			isLoaded: false
		};
	},
	components: {
		PartCostSearchContainer,
		PartCostTableContainer,
		PartCostTableMasterInfo,
		ExcelUploadModal
	},
	async created() {
		const value = (await this.inclManyUsrGrp_(['MQYPC', 'OS'])) ? 'MQYPC' : '';
		this.setState_({ key: 'authCode', value });
		this.isLoaded = true;
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		Refresh() {
			this.$sf_toggleLoading(false);
			this.$refs.partCostSearch.searchList();
		},
		sendData(param) {
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cpnyCd 는 ' + param.cpnyCd + ', cpnyNm은 ' + param.cpnyNm);
			this.sendParam = param;
		},
		PopupOpen(param) {
			this.$refs.excelUploadPop.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		}
	},
	computed: {
		...rootComputed,
		...qmsComputed,
		...serviceComputed
	}
};
</script>

<style></style>
